import { ReviewersEditLabel } from 'components/ReviewersEdit/ReviewersEditLabel';
import {
  GroupMultiSelect,
  InternalOption,
} from 'components/UIComponents/GroupMultiSelect';
import { ComponentProps, useCallback, useMemo } from 'react';
import { SingleSpan } from './CustomComponents';
import { SingleInputSection } from './SingleInputSection';

import './SingleGroupMultiSelectWithLabel.css';

type SelectProps = ComponentProps<typeof GroupMultiSelect>;

type Props = {
  className?: string;
  label: string;
  selected?: string[] | null;
  dropdownItems: SelectProps['groups'];
  readonly?: boolean;
  loading?: boolean;
  disabled?: boolean;
  onChange?: (value: string[]) => void;
};

export const SingleGroupMultiSelectWithLabel = ({
  className,
  label,
  readonly,
  selected,
  dropdownItems,
  loading,
  disabled,
  onChange,
}: Props) => {
  const dropdownItemsWithSelected = useMemo(
    () =>
      dropdownItems.map((item) => ({
        ...item,
        options: item.options.map((option) => ({
          ...option,
          checked: selected?.includes(option.value),
        })),
      })),
    [dropdownItems, selected],
  );

  const readOnlyValue = useMemo(() => {
    if (!readonly) return '';
    const commaItemsList = dropdownItemsWithSelected.map((r) =>
      r.options
        .filter((o) => o.checked)
        .map((o) => o.label)
        .join(', '),
    );
    return commaItemsList.join(', ');
  }, [dropdownItemsWithSelected, readonly]);

  const handleSubmit = useCallback(
    (selected: InternalOption[]) => {
      const ids = selected.map((o) => o.value);
      onChange?.(ids);
    },
    [onChange],
  );

  return (
    <SingleInputSection label={label} className={className}>
      {readonly ? (
        <SingleSpan>{readOnlyValue}</SingleSpan>
      ) : (
        <GroupMultiSelect
          className="single-group-multi-select__select"
          loading={loading}
          groups={dropdownItemsWithSelected}
          hasSearch
          mainLabelComponent={ReviewersEditLabel}
          disabled={disabled}
          onSubmit={handleSubmit}
        />
      )}
    </SingleInputSection>
  );
};
